export const GANHE_MAIS_CORRETOR_CLIENT_URL = 'ganhemaiscorretor';

export const PARCEIRO_CASHME_HOSTNAME = 'parceirocashme.oqdigital.com';
